import { format } from 'date-fns';

export const getImageURL = (data, variant = 'SQUARE') => {
  const urlImage = data?.thumbnails?.find(
    thumb => thumb?.type === variant
  )?.url;

  const validFormats = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg', '.webp'];

  return (
    validFormats?.some(
      imageType => urlImage?.endsWith(imageType) || urlImage?.startsWith('blob')
    ) && urlImage
  );
};

export const formatDate = date =>
  `Disponível até ${
    date ? format(new Date(date), 'dd/MM/yyyy') : '- Sem data limite'
  }`;
